exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.autocomplete[data-v-49e21edc] {\n  display: inline;\n}\n.dropdown-menu[data-v-49e21edc] {\n  border-style: solid;\n  border-width:  1px;\n}\nul>li[data-v-49e21edc] {\n  color: gray;\n  position: relative;\n}\nul>li[data-v-49e21edc]:hover {\n  color: black;\n}\n.active[data-v-49e21edc] {\n  color: white;\n  background-color: #0065B3;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-49e21edc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/AutocompleteSelection.vue
// module id = 508
// module chunks = 0